import React, { useEffect, useRef } from 'react';
export const TrustSection = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const testimonials = [{
    quote: 'Got certified same day. The process was seamless and the content was engaging. Exactly what our team needed.',
    author: 'Sarah M.',
    title: 'Restaurant Manager',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
  }, {
    quote: 'Managing compliance for 50 staff has never been easier. The dashboard is a game-changer for our multi-location business.',
    author: 'James T.',
    title: 'HR Director',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
  }, {
    quote: 'The enterprise solution transformed our training program. Worth every penny for the customization and reporting features.',
    author: 'Michelle K.',
    title: 'Compliance Officer',
    avatar: 'https://randomuser.me/api/portraits/women/68.jpg'
  }];
  return <section ref={sectionRef} className="py-24 bg-white opacity-0 transition-opacity duration-1000" data-id="element-4444">
      <div className="container mx-auto px-4 md:px-6" data-id="element-4445">
        <div className="max-w-5xl mx-auto" data-id="element-4446">
          <div className="max-w-4xl mx-auto mb-16 text-center" data-id="element-4447">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-charcoal tracking-tight" data-id="element-4448">
              Trusted and Proven
            </h2>
          </div>
          {/* Accreditation logos */}
          <div className="flex flex-wrap justify-center items-center gap-12 mb-20" data-id="element-4449">
            <div className="p-4" data-id="element-4450">
              <div className="text-gray-500 font-bold text-2xl" data-id="element-4451">
                CPD Certified
              </div>
            </div>
            <div className="p-4" data-id="element-4452">
              <div className="text-gray-500 font-bold text-2xl" data-id="element-4453">
                ROSPA Approved
              </div>
            </div>
            <div className="p-4" data-id="element-4454">
              <div className="text-gray-500 font-bold text-2xl" data-id="element-4455">
                Irish Trade Federation
              </div>
            </div>
          </div>
          {/* Testimonials */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-20" data-id="element-4456">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl p-8 shadow-lg border border-gray-200 transition-all duration-500 hover:shadow-xl transform hover:-translate-y-2 h-full" data-id="element-4457">
                <svg className="h-10 w-10 text-aqua mb-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-4458">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-4459" />
                </svg>
                <p className="text-xl mb-6 text-charcoal leading-relaxed" data-id="element-4460">
                  {testimonial.quote}
                </p>
                <div className="flex items-center mt-auto" data-id="element-4461">
                  <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-teal mr-4" data-id="element-4462">
                    <img src={testimonial.avatar} alt={testimonial.author} className="w-full h-full object-cover" data-id="element-4463" />
                  </div>
                  <div data-id="element-4464">
                    <p className="text-charcoal font-bold text-lg" data-id="element-4465">
                      {testimonial.author}
                    </p>
                    <p className="text-gray-500" data-id="element-4466">{testimonial.title}</p>
                  </div>
                </div>
              </div>)}
          </div>
          {/* Stats */}
          <div className="bg-white py-10 px-8 rounded-xl shadow-lg text-center border border-gray-200" data-id="element-4467">
            <p className="text-3xl font-bold text-charcoal relative inline-block" data-id="element-4468">
              <span className="text-teal" data-id="element-4469">97% completion rate.</span>{' '}
              <span className="text-charcoal" data-id="element-4470">100% acceptance.</span>
              <span className="absolute -bottom-2 left-0 w-full h-1 bg-aqua animate-pulse" data-id="element-4471"></span>
            </p>
          </div>
        </div>
      </div>
    </section>;
};